import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6902Model } from "../kymw6902.model";
import { GoodsModel } from "../vo/goods.model";
import { PagenationModel } from "../vo/pagenation.model";

interface GetGoodsListResponse {
  TotalNum: string;
  StartDispNum: string;
  EndDispNum: string;
  GoodsList: {
    GuideGoodsName: string;
    GuideStandardName: string;
    JanCode: string;
    BuyerName: string;
    PCode: string;
    ItemCode: string;
  }[];
}

/**
 * 商品一覧を取得するサービス
 *
 * @export GetGoodsListService
 * @class GetGoodsListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetGoodsListService extends PlessJsonResponderSub<GetGoodsListResponse> {
  private model: KYMW6902Model;
  private requestPage = 1;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        getGoodsByFeature: {
          condition: {
            PCode: this.model.searchParams.pCode,
            ItemCode: this.model.searchParams.itemCode,
            JanCode: this.model.searchParams.janCode,
            MakerName: this.model.searchParams.makerName,
            TagSearchType: this.model.searchParams.tagSearchType,
            GoodsMarkSearchType: this.model.searchParams.goodsMarkSearch,
            DataKbnFlg: this.model.searchParams.dataKbnFlg,
            GoodsDiv: this.model.searchParams.goodsDiv,
            BuyerCode: this.model.searchParams.buyerCode,
            AdmitStatus: this.model.searchParams.admitStatus,
            RegistDateFrom: this.model.searchParams.registDateFrom,
            RegistDateTo: this.model.searchParams.registDateTo,
            UpdateDateFrom: this.model.searchParams.updateDateFrom,
            UpdateDateTo: this.model.searchParams.updateDateTo,
            ClassCode: this.model.searchParams.classCode,
            MiddleClassCode: this.model.searchParams.middleClassCode,
            SmallClassCode: this.model.searchParams.smallClassCode,
            OrdrClientCode: this.model.searchParams.orderClientCode,
            OrdrClientKanji: this.model.searchParams.orderClientKanji,
            PayeeClientCode: this.model.searchParams.payeeClientCode,
            PayeeClientKanji: this.model.searchParams.payeeClientKanji,
            Page: this.requestPage
          }
        },
        TagIdList: {
          combination: this.createCombination(this.model.searchParams.tagIdList, 'TagId')
        },
        GoodsMarkList: {
          combination: this.createCombination(this.model.searchParams.goodsMarkList, 'GoodsMark')
        },
        CoopCodeList: {
          combination: this.createCombination(this.model.searchParams.coopCodeList, 'CoopCode')
        },
        PCodeList: {
          combination: this.createCombination(this.model.searchParams.pCodeList, 'PCode')
        },
        ItemCodeList: {
          combination: this.createCombination(this.model.searchParams.itemCodeList, 'ItemCode')
        },
        DutiesList: {
          combination: this.createCombination(this.model.searchParams.duties, 'Duties')
        },
        GuideGoodsNameList: {
          combination: this.createCombination(this.model.searchParams.guideGoodsNames, 'GuideGoodsName')
        },
        GuideStandardNameList: {
          combination: this.createCombination(this.model.searchParams.guideStandardNames, 'GuideStandardName')
        }
      }
    });
  }

  private createCombination<T>(list: T[], parameterName: string) {
    if (list.length === 0) {
      return [{
        condition: {
          [parameterName]: ''
        }
      }];
    }
    return list.map(item => ({
      condition: {
        [parameterName]: item
      }
    }));
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetGoodsListService
   */
  execute(model: KYMW6902Model, requestPage: number, successFunc?: () => void): void {
    this.model = model;
    this.requestPage = requestPage;
    this.successFunc = successFunc;
    this.send('getGoodsList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMasterInputService
   */
  success(data: GetGoodsListResponse): void {
    this.model.pagenation = new PagenationModel(
      this.requestPage,
      Number(data.TotalNum),
      Number(data.StartDispNum),
      Number(data.EndDispNum)
    );

    this.model.goodsList = data.GoodsList.map((goods, index) => new GoodsModel(
      index,  // id
      goods.GuideGoodsName,
      goods.GuideStandardName,
      goods.JanCode,
      goods.BuyerName,
      goods.PCode,
      goods.ItemCode
    ));
    
    // 初期値をidで指定
    this.model.selectedRowIndex = this.model.goodsList[0].id;

    if (this.successFunc) {
      this.successFunc();
    }
  }
}

